import React from 'react';
import { Modal, ModalBody, Button } from 'react-bootstrap';

export const ConfirmModal = ({ show, onHide, onConfirm, title, message, btntxt="Confirm"}) => {
  return (
    <Modal size="md" show={show} onHide={onHide} centered>
      <div className="modal-content confirm-mdl-popup">
        <ModalBody className="px-4 py-5 text-center">
          <button type="button" onClick={onHide} className="btn-close position-absolute end-0 top-0 m-3"></button>
          <div className="avatar-sm mb-4 mx-auto confirm-mdl-title">
            <div className='confirm-mdl-titletxt'> {title || 'Confirm'} </div>
          </div>
          <p className="text-muted font-size-16 mb-4">{message || 'Are you sure you want to proceed?'}</p>

          <div className="hstack gap-2 justify-content-center mb-0">
            <button type="button" className="btn btn-danger" onClick={onConfirm}>{btntxt}</button>
            <button type="button" className="btn btn-secondary" onClick={onHide}>Close</button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  );
};

